/**
 * 都道府県と地方の対応表。
 *
 * 県選びの並べ方に使う。11県では箇条書きでも足りるが、47県では破綻するので
 * 地方でまとめる。将来の日本地図UIでも、この表をそのまま使えるようにしてある。
 *
 * 並び順は都道府県コード順。地方の分け方は、中国と四国をまとめた6区分にした。
 * 47県そろったときに1グループが3〜4県だと、かえって探しにくいため。
 *
 * regionId は StageDefinition の regionId と一致させる（ローマ字・小文字）。
 * ここに載っていない regionId（ご当地ステージなど）は「その他」に入る。
 */

export type AreaId = 'hokkaido-tohoku' | 'kanto' | 'chubu' | 'kinki' | 'chugoku-shikoku' | 'kyushu';

export interface AreaDefinition {
  id: AreaId;
  name: string;
  /** この地方に属する regionId（都道府県コード順）。 */
  regionIds: readonly string[];
}

export const AREAS: readonly AreaDefinition[] = [
  {
    id: 'hokkaido-tohoku',
    name: '北海道・東北',
    regionIds: ['hokkaido', 'aomori', 'iwate', 'miyagi', 'akita', 'yamagata', 'fukushima'],
  },
  {
    id: 'kanto',
    name: '関東',
    regionIds: ['ibaraki', 'tochigi', 'gunma', 'saitama', 'chiba', 'tokyo', 'kanagawa'],
  },
  {
    id: 'chubu',
    name: '中部',
    regionIds: [
      'niigata', 'toyama', 'ishikawa', 'fukui', 'yamanashi',
      'nagano', 'gifu', 'shizuoka', 'aichi',
    ],
  },
  {
    id: 'kinki',
    name: '近畿',
    regionIds: ['mie', 'shiga', 'kyoto', 'osaka', 'hyogo', 'nara', 'wakayama'],
  },
  {
    id: 'chugoku-shikoku',
    name: '中国・四国',
    regionIds: [
      'tottori', 'shimane', 'okayama', 'hiroshima', 'yamaguchi',
      'tokushima', 'kagawa', 'ehime', 'kochi',
    ],
  },
  {
    id: 'kyushu',
    name: '九州・沖縄',
    regionIds: [
      'fukuoka', 'saga', 'nagasaki', 'kumamoto', 'oita',
      'miyazaki', 'kagoshima', 'okinawa',
    ],
  },
];

/** regionId -> 地方。表を1回だけ引っくり返して持つ。 */
const AREA_BY_REGION: ReadonlyMap<string, AreaDefinition> = new Map(
  AREAS.flatMap((area) => area.regionIds.map((regionId) => [regionId, area] as const)),
);

/** regionId が属する地方。表にない場合は undefined。 */
export function areaOf(regionId: string): AreaDefinition | undefined {
  return AREA_BY_REGION.get(regionId);
}

/** 47都道府県ぶんの regionId が漏れなく載っているかの確認用。 */
export const ALL_PREFECTURE_IDS: readonly string[] = AREAS.flatMap((a) => a.regionIds);
